import userManagement from "./userManagement";
import disciplines from "./disciplines";
import fillWord from "./fillWord";

export default {
  userManagement,
  disciplines,
  fillWord,
};
